(() => {
  angular
    .module('gm.common.directives')
    .directive('gmFlyoutOpen', gmFlyoutOpenDirective);

  function gmFlyoutOpenDirective() {
    'ngInject';

    return {
      restrict: 'A',

      link(_scope, element, attrs) {
        const eventName = attrs.gmFlyoutOpen || 'click';

        element.on(eventName, () => {
          element.trigger('gm:flyout-open');
        });
      },
    };
  }
})();
